// extracted by mini-css-extract-plugin
module.exports = {"flexCardListItem":"Card_flexCardListItem__1UgbI","flexCard":"Card_flexCard__aF9iL"};